<template>
	<div class="quote">
		<div v-if="initDone" class="quote-indicator">
			<SlideStockPrice :stock-quote-data="stockQuoteData" />
			<SlideStockIndex :stock-quote-data="stockQuoteData" />
		</div>
		<div class="quote-echart">
			<div class="quote-echart-tab" v-if="isKType">
				<CommonTab type="rect-primary" :value.sync="kLineActValue" :option="kLineTabList" />
			</div>

			<div>
				<KChart v-if="isKType" ref="compKChart" :time="kLineActValue" />
				<AreaChart v-else ref="compKChart" />
			</div>
		</div>
		<p class="statement">{{ $t('enterprise.disclaimer') }}</p>
	</div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import KChart from '@rebuild/materials/shared/quote/KChart.vue';
import AreaChart from '@rebuild/materials/shared/quote/AreaChart.vue';
import SlideStockIndex from '@rebuild/materials/shared/quote/slideStockIndex.vue';
import SlideStockPrice from '@rebuild/materials/shared/quote/slideStockPrice.vue';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import { useModuleConfig } from '@rebuild/hooks/data/useModuleConfig';
import { useKLineTabs } from '@rebuild/materials/shared/quote/useKLineTabs';

const stockQuoteData = ref({});

const { config, loadModuleConfig } = useModuleConfig();
const isKType = computed(() => {
	return config.value.displayForm == 1 || !config.value.displayForm;
});

const { quote } = useModuleData();
const queryStockQuote = async () => {
	await quote.refresh();
	return quote.data?.data;
};

const compKChart = ref();
const { kLineActValue, kLineTabList } = useKLineTabs();

const initDone = ref(false);
const refresh = () => {
	loadModuleConfig('quote');
	const onceQuery = async () => {
		const result = await queryStockQuote();
		if (!initDone.value) initDone.value = true;
		if (result) {
			stockQuoteData.value = result;
		}
	};
	onceQuery();
};
onMounted(() => {
	refresh();
});
</script>

<style lang="less"></style>

<style lang="less" scoped>
.quote {
	.quote-indicator {
		display: flex;
		justify-content: space-between;
	}

	.quote-echart {
		margin-top: 20px;

		.quote-echart-tab {
			display: flex;
			justify-content: space-between;
		}
	}
	.statement {
		text-align: right;
		margin-top: 20px;
		color: var(--t-secondary-info-color, #86909c);

		font-size: 10px;

		font-weight: 400;
		line-height: normal;
	}
}
</style>
